import { createSelector, createFeatureSelector } from '@ngrx/store';
import { BookingState, bookingsFeatureKey } from './booking.state';
import { adapter } from './booking.entity';
import { Predicate } from '@angular/core';
import { Booking } from '../models/booking';

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();

export const getBookingState = createFeatureSelector<BookingState>(bookingsFeatureKey);

export const getAllBookings = createSelector(getBookingState, selectAll);

export const getBookingById = (id: string) => createSelector(getBookingState, (state) => state.entities[id]);

export const getError = createSelector(getBookingState, (state) => state.error);

export const getPageIndex = createSelector(getBookingState, (state) => state.pageIndex);

export const getFilter = createSelector(getBookingState, (state) => state.filter);

export const getTotalCount = createSelector(getBookingState, (state) => state.totalCount);

export const getActiveCount = createSelector(getBookingState, (state) => state.activeCount);

export const getPendingCount = createSelector(getBookingState, (state) => state.pendingCount);

export const getUpcomingCount = createSelector(getBookingState, (state) => state.upcomingCount);

export const getHistoryCount = createSelector(getBookingState, (state) => state.historyCount);

export const getUserMode = createSelector(getBookingState, (state) => state.isGuide);

export const getServiceProviderId = createSelector(getBookingState, (state) => state.serviceProviderId);

export const getServiceProviderView = createSelector(getBookingState, (state) => state.serviceProviderView);

export const getBookingServiceProviderInfo = createSelector(getServiceProviderView,getServiceProviderId,(serviceProviderView,serviceProviderId) => ({serviceProviderView,serviceProviderId}));

export const getIsCourseBooked = createSelector(getBookingState, (state) => state.isCourseBooked);

export const getBookingBySearch = (predicate: Predicate<Booking>) =>
  createSelector(getAllBookings, (state) => state.filter(predicate));

  export const getParticipants = createSelector(getBookingState, (state) => state.participants);
